import { gridClasses, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import { DateTime } from "luxon";
import React from "react";
import { padTime } from "../util/dateTimeFormatter";
import { getTimeZoneFromSwaStation } from "../util/timeZoneService";

export default function AdminTimeOffRequestToolbar(props) {
  const date = DateTime.now().setZone(getTimeZoneFromSwaStation(props.station));
  const fileName = `STARS_Time_Off_${padTime(date.month)}-${padTime(date.day)}-${date.year}_${padTime(
    date.hour
  )}${padTime(date.minute)}`;
  const columns = [
    "station",
    "referenceNumber",
    "timeOffRequestType",
    "visibleStatus",
    "lastUpdatedDate",
    "employeeName",
    "employeeId",
    "workgroup",
    "shift",
  ];
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport csvOptions={{ fileName: fileName, fields: columns }} printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}
